@if (healthHistory != null && healthHistory.length > 0) {
  <div class="card booking-card mt-3">
    <div class="card-header booking-card__header">
      <div>
        <div class="booking-card__eyebrow">Medical History</div>
        <h3 class="sub-title mb-0">Past Health Records</h3>
      </div>
      <span class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill">
        {{ healthHistory.length }} record{{ healthHistory.length === 1 ? '' : 's' }}
      </span>
    </div>

    <div class="table-responsive">
      <table class="table table-hover align-middle mb-0">
        <thead>
          <tr>
            <th>Diagnosis</th>
            <th>Doctor Notes</th>
            <th>Diagnosis Date</th>
            <th>Practitioner</th>
          </tr>
        </thead>
        <tbody>
          @for (item of healthHistory; track item.id) {
            <tr>
              <td>
                <span class="fw-bold text-dark">{{ item.diagnosis || '—' }}</span>
              </td>
              <td>
                <span class="text-secondary small">{{ item.notes || '—' }}</span>
              </td>
              <td class="text-nowrap text-muted small">
                {{ item.medicalRecordDate ? (item.medicalRecordDate | date: 'dd MMM yyyy') : '—' }}
              </td>
              <td>
                <span class="badge bg-light text-dark border">{{
                  item.practitionerName || '—'
                }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
} @else {
  <div class="empty-state empty-state--compact mt-3">
    <i class="bi bi-journal-medical fs-3 d-block mb-2 text-primary"></i>
    No past health history records available.
  </div>
}
